import React, { ButtonHTMLAttributes } from "react";
import { useGetMinimumOrderAmount } from "../../../hooks";
import { useCartData } from "../../../providers/cartDataStore";
import { useGetShippingMethodsQuery } from "../../../providers/shippingAndPayment";
import { useActiveOrMainShippingZone } from "../../../providers/shippingZones";

import cx from "classnames";

interface ProgressBarButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonText?: string;
  wrapClassName?: string;
}

const ProgressBarButton = ({ buttonText, wrapClassName, ...buttonProps }: ProgressBarButtonProps) => {
  const { cartSubtotalValue } = useCartData();
  const { activeShippingZone } = useActiveOrMainShippingZone();
  const { minimumOrderAmount } = useGetMinimumOrderAmount();
  const { id: activeShippingZoneId } = activeShippingZone;

  const { getProductsTotalWeight } = useCartData();

  const { isLoading: isShippingMethodsLoading } = useGetShippingMethodsQuery(
    activeShippingZoneId,
    getProductsTotalWeight(),
    {
      enabled: !!activeShippingZoneId,
    },
  );

  const progress = Math.min((cartSubtotalValue / minimumOrderAmount) * 100, 100);

  return (
    <div
      className={cx("relative rounded-3xl overflow-hidden bg-[#fed7006b]", {
        "opacity-60": buttonProps?.disabled,
      })}
    >
      <div
        style={{ width: `${progress}%` }}
        className={cx("absolute z-[-1] w-full h-full transition-width duration-300 bg-primary", {
          "bg-gray-500": !!activeShippingZoneId && isShippingMethodsLoading,
        })}
      />
      <button {...buttonProps} className={cx("w-[22rem] h-full text-[0.875rem] font-bold py-4", buttonProps.className)}>
        {buttonText}
      </button>
    </div>
  );
};

export default ProgressBarButton;
